import { useEffect, useState } from 'react';
import { availableStages } from '@/impactReports/impactReport.types';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { sqImpactReportStore, sqWorkbenchStore } from '@/core/core.stores';
import { useAsyncEffect } from 'rooks';
import { getStageIndex, initializeImpactReportCategories } from '@/impactReports/impactReport.utilities';
import { ImpactReportForm, ImpactReportHeader } from '@/impactReports/ImpactReportForm.page';
import { Modal } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';
import { SeeqNames } from '@/main/app.constants.seeqnames';

interface ImpactReportEditModalProps {
  closeFn: (reloadTable?: boolean) => void;
  existingReport?: Record<string, any>;
}

export const ImpactReportEditModal: React.FunctionComponent<ImpactReportEditModalProps> = ({
  closeFn,
  existingReport,
}) => {
  const maxStageIndex = availableStages?.length;
  const { t } = useTranslation();
  const stateParams = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.stateParams);
  const [workbookId, setWorkbookId] = useState<string>(
    existingReport ? existingReport[SeeqNames.ImpactReport.AssignedToWorkbook] : '',
  );
  const [worksheetId, setWorksheetId] = useState<string>(
    existingReport ? existingReport[SeeqNames.ImpactReport.AssignedToWorksheet] : '',
  );
  const [stageIndex, setStageIndex] = useState(0);
  const categories = useFluxPath(sqImpactReportStore, () => sqImpactReportStore.categories);

  useEffect(() => {
    if (existingReport) return;
    setWorkbookId(stateParams?.workbookId);
    setWorksheetId(stateParams?.worksheetId);
  }, [stateParams]);

  useAsyncEffect(async () => {
    if (!categories) {
      await initializeImpactReportCategories();
    }
  }, []);

  useEffect(() => {
    if (!existingReport) return;
    const idx = getStageIndex(existingReport[SeeqNames.ImpactReport.ImpactStatus]);
    setStageIndex(idx < maxStageIndex - 1 ? idx + 1 : idx);
  }, [existingReport]);

  return categories ? (
    <Modal
      testId="impactReportEditModal"
      hideFooterButtons={true}
      open={true}
      size="4xl"
      onClose={closeFn}
      title={t('IMPACT_REPORT.CAPTURE_IMPACT')}
      customHeader={
        <ImpactReportHeader
          workbookId={workbookId}
          worksheetId={worksheetId}
          stageIndex={stageIndex}
          setStageIndex={setStageIndex}
          setWorkbookId={setWorkbookId}
          setWorksheetId={setWorksheetId}
        />
      }>
      <div className="valueCapture valueCaptureModalHeight">
        <ImpactReportForm
          categories={categories}
          report={existingReport}
          stageIndex={stageIndex}
          workbookId={workbookId}
          worksheetId={worksheetId}
          setWorkbookId={setWorkbookId}
          setWorksheetId={setWorksheetId}
          setStageIndex={setStageIndex}
          closeFn={closeFn}
        />
      </div>
    </Modal>
  ) : null;
};
